import { useDispatch } from 'react-redux';

export default function useStoreHealthQuestionnaire() {
    const dispatch = useDispatch();

    const executor = (healthQuestionnaire) => {
        return dispatch({
            type: 'SET_HEALTH_QUESTIONNAIRE',
            payload: healthQuestionnaire,
        });
    };

    return executor;
};